import { get } from 'lodash';

import { Expense, Expenses } from '@funnels/types';
import { FIELD_PATHS, FREQUENCY } from '@funnels/constants';

import { convert } from './conversions';

export default function normaliseExpensesByFrequency(expenses: Expenses[], frequency: FREQUENCY) {
  return expenses.map((expenses: Expenses) => ({
    ...expenses,
    expenses: get({ expenses: [expenses] }, FIELD_PATHS.EXPENSES_EXPENSES(0), []).map((expense: Expense) => ({
      ...expense,
      frequency,
      amount:
        expense.amount !== undefined ? convert(expense.amount, expense.frequency as FREQUENCY, frequency) : undefined,
    })),
  }));
}
